import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { IsLoadingService } from 'src/app/services/loading.service';
import { filter } from 'rxjs/operators';
import { NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavService } from 'src/app/services/nav.service';
import { NavItem } from 'src/app/model/nav-item';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OktaAuthService } from '@okta/okta-angular';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { SpotfireService } from 'src/app/services/spotfire.service';
import { SortByPipe } from 'src/app/pipes/sort-by.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fsclayout',
  templateUrl: './fsclayout.component.html',
  styleUrls: ['./fsclayout.component.scss']
})
export class FsclayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('appDrawer') appDrawer: ElementRef;

  title = 'Fsc Customer Portal';
  togglParent = true;
  isLoading: Observable<boolean>;
  navItems: NavItem[];
  searchValue: string = '';
  navItemCopy: NavItem[];
  opened: boolean;
  hideLeftNav = false;
  isSmallScreen = false;
  constructor(
    public router: Router,
    private isLoadingService: IsLoadingService,
    private navService: NavService,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private oktaAuth: OktaAuthService,
    private fclLoginService: FclLoginService,
    private spotfireService: SpotfireService,
    private sortByPipe: SortByPipe
  ) {

    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
      Breakpoints.Handset,
      Breakpoints.Tablet,
      Breakpoints.Web,
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait,
      Breakpoints.WebPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.TabletLandscape,
      Breakpoints.WebLandscape
    ]).subscribe(result => {
      if (result.matches) {
        this.isSmallScreen = breakpointObserver.isMatched('(max-width: 599px)');
      }
    });
  }

  filteredItems = [];
  /*
    async updateResults() {
      console.log(this.searchValue);
      if (this.searchValue.length!=0) {
        const navItemsFromService: NavItem[] = this.navService.getNavItemsFromSelectedModule();
        this.setNavigationItems(navItemsFromService);  
        this.filteredItems = [this.searchByValue(this.filteredItems, this.searchValue)];
      } else if (this.searchValue.trim().length === 0) {
        this.filteredItems = this.navItemCopy;
      }
    }
  
    searchByValue(array, dirName) {
      console.log(dirName.trim() === '');
  
      for (let i = 0; i < array.length; i++) {
        console.log(array[i].displayName.toLocaleLowerCase());
        console.log(dirName.trim().toLocaleLowerCase());
        if (
          array[i].displayName
            .toLowerCase()
            .includes(this.searchValue.trim().toLocaleLowerCase())
        ) {
          return array[i];
        } else if (array[i].children && array[i].children.length) {
          const result = this.searchByValue(array[i].children, dirName);
          // return the result only if it's actually found otherwise keep looping
          if (result) return result;
        }
      }
    }
    */

  async updateResults() {
    this.filteredItems = this.searchByValue(this.navItems, this.searchValue);
  }

  assignCopy() {
    this.filteredItems = Object.assign([], this.navItems);
    return this.filteredItems
  }

  searchByValue(items, searchValue) {
    if (!searchValue) {
      return this.assignCopy();
    } else {

      const flatObject = this.flatten();

      return this.filteredItems = Object.assign([], flatObject).filter(
        item => this.translateService.instant(item.displayName).toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      )
    }
  }

  flatten() {
    var flatObject = [];
    for (let i=0; i< this.navItems.length; i++) {
      if (this.navItems[i].route) {
        flatObject.push(this.navItems[i]);
      }

      if (this.navItems[i].children ) {
        for (let j =0; j < this.navItems[i].children.length; j++) {
          if (this.navItems[i].children && this.navItems[i].children[j].route) {
            flatObject.push(this.navItems[i].children[j]);
          }
          if (this.navItems[i].children[j].children ) {
            for (let k =0; k < this.navItems[i].children[j].children.length; k++) {
              if (this.navItems[i].children[j].children && this.navItems[i].children[j].children[k].route) {
                flatObject.push(this.navItems[i].children[j].children[k]);
              }
            }
          }
        }
      }
    }
  
    return flatObject;
  };
    
  resetNavItems() {
    this.filteredItems = this.navItems;
  }

  async ngOnInit() {
    this.isLoading = this.isLoadingService.isLoading$();
    await this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe(event => {
        this.hideLeftNav = (this.router.url === '/home');
        this.isLoadingService.remove();
        if (event instanceof NavigationStart) {
          this.isLoadingService.add();
          return;
        }
        this.isLoadingService.remove();
      });

    const navItemsFromService: NavItem[] = this.navService.getNavItemsFromSelectedModule();
    this.setNavigationItems(navItemsFromService);

    this.navService.navItems$.subscribe(
      (res: NavItem[]) => {
        this.updateResults();
        this.setNavigationItems(res);
      }, error => {
        console.log(error);
      });


    if (!this.spotfireService.cookiesSet) {
      if (this.fclLoginService.getUserType() === 'I') {
        const authenticated = await this.oktaAuth.isAuthenticated();
        if (authenticated) {
          this.spotfireService.setTokenOrCookie();
        }
      } else if (this.fclLoginService.getUserType() === 'E') {
        const authenticated = this.fclLoginService.isUserLoggedIn;
        if (authenticated) {
          this.spotfireService.setTokenOrCookie();
        }
      }
      this.spotfireService.cookiesSet = true;
    }
  }

  setNavigationItems(navigationItems: NavItem[]) {
    this.navItems = navigationItems;
    if (navigationItems.length > 0) {
      if (navigationItems[0].id !== '0GP0_P0_C0_HOME') {
        this.navItems.unshift(this.navService.getHomeNode());
      }
    }
    if(this.navItems.length >0) {
      for(let i=0; i< this.navItems.length ; i++) {
        if (this.navItems[i].displayName === 'Reports' && this.navItems[i].children ) {
          for (let j =0; j < this.navItems[i].children.length; j++) {
            if (this.navItems[i].children[j].displayName === 'ATT' && this.navItems[i].children[j].children) {
              this.navItems[i].children[j].children = this.sortByPipe.transform(this.navItems[i].children[j].children, true, 'asc', 'displayName');
            }
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.appDrawer;
    this.resizeGrid();
    window.addEventListener('resize', (event) => {
        this.resizeGrid();
    }, true);
  }

  resizeGrid(){
    let windowWidth = window.innerWidth;
    if(windowWidth < 1201){
      this.navService.appDrawer.close();
    } else {
      this.navService.appDrawer.open();
    }
  }


  openClosed(openedOrClosed: string) {
    this.opened = (openedOrClosed === 'open');
  }

}
